import { IOrderPendingServiceMock } from "./order_pending.types";

export const mockOrderPendingService = (): IOrderPendingServiceMock => ({
  getOrdersPending: jest.fn(),
});
